import { useLocation } from 'react-router-dom';
import { PageHeader } from './PageHeader';
import { getPageConfig, usePageHeaderOverride } from '../../utils';

export const GlobalBreadcrumb = () => {
  const location = useLocation();
  const override = usePageHeaderOverride();
  // A page can announce its own PageConfig once data it fetched itself (e.g. a team's real
  // display name) is available — see utils/pageHeaderOverride.ts for why this is needed
  // instead of getPageConfig alone.
  const pageConfig = override ?? getPageConfig(location.pathname);

  if (!pageConfig) {
    return null;
  }

  return (
    <PageHeader
      title={pageConfig.title}
      titleLoading={pageConfig.titleLoading}
      breadcrumbs={pageConfig.breadcrumbs}
      description={pageConfig.description}
      extra={pageConfig.extra}
      showDate
    />
  );
};
